import { useLocation } from 'react-router-dom';
import s from "./Dynmap.module.scss";

export default function Dynmap() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const server: string | undefined = queryParams.get('server') || undefined;

    return (<iframe className={s.fullFrame} src={`https://atownyserver.com/dynmap/${server ? server : "archives"}/`} />);
}